import React, { Suspense } from 'react'
import PropTypes from 'prop-types'
import { Router } from '@fs/zion-router'
import { Providers, Theme } from '@fs/zion-ui'
import { I18nProvider } from '@fs/zion-locale'
import ErrorBoundary from '@fs/zion-error-boundary'
import { FrontierBaseProviders } from '@fs/zion-root'

export default function Wrapper({ mockFlags, mockActivities, children }) {
  return (
    <React.StrictMode>
      <ErrorBoundary>
        <Suspense fallback={null}>
          <FrontierBaseProviders mockFlags={mockFlags} mockActivities={mockActivities}>
            <Router>
              <Theme theme="day">
                <I18nProvider>
                  <Providers>{children}</Providers>
                </I18nProvider>
              </Theme>
            </Router>
          </FrontierBaseProviders>
        </Suspense>
      </ErrorBoundary>
    </React.StrictMode>
  )
}

Wrapper.propTypes = {
  mockFlags: PropTypes.objectOf(
    PropTypes.shape({
      treatment: PropTypes.bool,
    })
  ),
  mockActivities: PropTypes.objectOf(
    PropTypes.shape({
      experienceId: PropTypes.string,
      color: PropTypes.string,
      buttonEmphasis: PropTypes.string,
    })
  ),
  children: PropTypes.node.isRequired,
}
